import { render, staticRenderFns } from "./showWheelBet.vue?vue&type=template&id=7321827a&scoped=true&"
import script from "./showWheelBet.vue?vue&type=script&lang=js&"
export * from "./showWheelBet.vue?vue&type=script&lang=js&"
import style0 from "./showWheelBet.vue?vue&type=style&index=0&id=7321827a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321827a",
  null
  
)

export default component.exports